import Vue from 'vue'

function numberFormat (number, decimals = 0, decPoint = '.', thousandsSep = ',') {
  const sign = number < 0 ? '-' : ''
  const sNumber = Math.abs(parseInt(number = (+number || 0).toFixed(decimals))) + ''
  const len = sNumber.length
  const tchunk = len > 3 ? len % 3 : 0
  const chFirst = (tchunk ? sNumber.substr(0, tchunk) + thousandsSep : '')
  const chRest = sNumber.substr(tchunk).replace(/(\d\d\d)(?=\d)/g, '$1' + thousandsSep)
  const chLast = decimals ? decPoint + (Math.abs(number) - sNumber).toFixed(decimals).slice(2) : ''
  return sign + chFirst + chRest + chLast
}

Vue.filter('currency', function (value) {
  if (!value) return 0

  return numberFormat(value, 0, '.', ' ')
})
